jQuery(document).ready(function($) {

  $(document).on('click', '.pagination' ,(event) => {
    $target = $(event.target);
    var page = parseInt($target.attr('data-page'));
    var postType = $target.attr('data-post-type');
    var category = $target.attr('data-category');

    $.ajax({
        url : loadmore_params.ajaxurl,
        data : {
            'action': postType + '_ajax',
            'page' : page,
            'category' : category
        },
        type : 'POST',
        success : function( data ){
              $('.ajax-target').html(data);
              $('html, body').animate({
        			  scrollTop: $(".ajax-target").offset().top - 150
        			}, 500);
            }
          })
  })

})
